import ForgotPasswordForm from "../components/forgot-password";

const ForgotPassPage = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPassPage;
